import Vue from 'vue';

const eventus = {
  init() {
    window.Eventus = new Vue();
  },
};

export { eventus };



// WEBPACK FOOTER //
// ./src/services/eventus.js